import { useAuth } from '@nike/aegis-auth-react';
import { AuthState } from '@nike/aegis-auth-react/dist/types/store';
import { createContext } from 'react';
import aegisClient from './aegisClient';

export const AuthContext = createContext<AuthState | {}>({});

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const authBundle = useAuth(aegisClient);

  return <AuthContext.Provider value={authBundle}>{children}</AuthContext.Provider>;
};